<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view :key="locale"/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    locale (value) {
      // 更新 i18n
      this.$i18n.locale = value
    }
  },
  computed: {
    locale () {
      return this.$store.state.setting.locale
    }
  }
}
</script>
<style lang='scss' scoped>

#app {
  position: relative;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue